import { DevelopmentalData } from "@/types/developmental";

export const age1Activities: DevelopmentalData = {
  motor: [
    "Practice walking on different surfaces",
    "Roll and catch soft balls",
    "Stack blocks and knock them down",
    "Scribble with large crayons",
    "Dance to music"
  ],
  language: [
    "Read picture books together",
    "Name objects during daily activities",
    "Sing simple songs",
    "Play naming games",
    "Respond to simple commands"
  ],
  cognitive: [
    "Sort objects by color",
    "Play hide-and-seek with toys",
    "Match simple shapes",
    "Explore cause and effect toys",
    "Practice counting objects"
  ],
  independent: [
    "Practice using spoon and cup",
    "Encourage self-dressing attempts",
    "Simple cleaning tasks",
    "Hand washing practice",
    "Choose between two options"
  ],
  social: [
    "Supervised playdates",
    "Mirror play activities",
    "Simple turn-taking games",
    "Family meal participation",
    "Gentle sharing practice"
  ]
};